import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle, Label, DropdownItem, DropdownMenu } from 'reactstrap';
import { Link } from 'react-router-dom';
import ShopFilterSearchTextbox from '../components/ShopFilterSearchTextbox.js';
import ShopCurrentFilters from '../components/ShopCurrentFilters.js';
import ShopProductListing from '../components/ShopProductListing.js';


export default class ShopFilterCollapseUnder768 extends Component {
  static propTypes = {
    windowWidth: PropTypes.number.isRequired,
    toggleFilter: PropTypes.func.isRequired,
    toggleProductCategory: PropTypes.func.isRequired,
    togglePureMaple: PropTypes.func.isRequired,
    toggleExtraValue: PropTypes.func.isRequired,
    toggleNonMaple: PropTypes.func.isRequired,
    pureMapleCheck: PropTypes.func.isRequired,
    extraValueCheck: PropTypes.func.isRequired,
    nonMapleCheck: PropTypes.func.isRequired,
    pureSyrupCheck: PropTypes.func.isRequired,
    pureCreamCheck: PropTypes.func.isRequired,
    pureCandyCheck: PropTypes.func.isRequired,
    pureSugarCheck: PropTypes.func.isRequired,
    extraSaucesCheck: PropTypes.func.isRequired,
    extraBeveragesCheck: PropTypes.func.isRequired,
    extraCandyCheck: PropTypes.func.isRequired,
    extraJellyCheck: PropTypes.func.isRequired,
    extraGiftSetsCheck: PropTypes.func.isRequired,
    nonPancakeMixesCheck: PropTypes.func.isRequired,
    nonInformationalCheck: PropTypes.func.isRequired,
    nonClothesCheck: PropTypes.func.isRequired,
    nonCandlesCheck: PropTypes.func.isRequired,
    nonKitchenwareCheck: PropTypes.func.isRequired,
    nonBooksCheck: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const ShopFilterScreen_Under768 = ( 
      <ShopFilterScreen_Under768_CollapseDiv>
        <ShopFilterScreen_Under768_Collapse navbar isOpen={this.props.filterOpen}>
          <Nav className="ml-auto" navbar >
            <NavItem >
              <NavLink onClick={this.props.toggleFilter} >
                  <SpanInDropdown>Filter</SpanInDropdown>
                  <img src={require("../media/tinyX.png")} ></img>
              </NavLink>
            </NavItem>

            {/* ******************************** PRODUCT CATEGORY DROPDOWN ******************************** */}
            <Dropdown nav isOpen={this.props.productCategoryOpen} toggle={this.props.toggleProductCategory } >
              <DropdownToggle_s nav caret productCategoryOpen={this.props.productCategoryOpen} >
                  <SpanHeader>Product Category</SpanHeader>
              </DropdownToggle_s>
              <DropdownMenu>
                
                <DropdownItem onChange={this.props.pureMapleCheck} toggle={false} >
                  <Container >
                      <Label check >
                         <Input type="checkbox"
                          checked={this.props.checked_pureMapleProducts} 
                           /> {' '}
                         <p>Pure Maple Products</p>
                       </Label>
                  </Container>
                </DropdownItem>
                
                <DropdownItem onChange={ this.props.extraValueCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_extraValueProducts} 
                           /> {' '}
                         <p>Extra Value Products</p>
                       </Label>
                  </Container>
                </DropdownItem>
                <DropdownItem onChange={ this.props.nonMapleCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_nonMapleProducts} 
                           /> {' '}
                         <p>Non Maple Products</p>
                       </Label>
                  </Container>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>

            {/* ******************************** PURE MAPLE DROPDOWN ******************************** */}
            <Dropdown nav isOpen={this.props.pureMapleOpen} toggle={this.props.togglePureMaple} >
              <DropdownToggle_s nav caret productCategoryOpen={this.props.pureMapleOpen} >
                  <SpanHeader>Pure Maple Products</SpanHeader>
              </DropdownToggle_s>
              <DropdownMenu>
                
                <DropdownItem onChange={this.props.pureSyrupCheck} toggle={false} >
                  <Container >
                      <Label check >
                         <Input type="checkbox"
                          checked={this.props.checked_pureSyrup} 
                           /> {' '}
                         <p>Syrup</p>
                       </Label>
                  </Container>
                </DropdownItem>
                
                <DropdownItem onChange={ this.props.pureCreamCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_pureCream} 
                           /> {' '}
                         <p>Cream</p>
                       </Label>
                  </Container>
                </DropdownItem>

                <DropdownItem onChange={ this.props.pureCandyCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_pureCandy} 
                           /> {' '}
                         <p>Candy</p>
                       </Label>
                  </Container>
                </DropdownItem>

                <DropdownItem onChange={ this.props.pureSugarCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_pureSugar} 
                           /> {' '}
                         <p>Sugar</p>
                       </Label>
                  </Container>
                </DropdownItem>

              </DropdownMenu>
            </Dropdown>

            {/* ******************************** EXTRA VALUE DROPDOWN ******************************** */}
            <Dropdown nav isOpen={this.props.extraValueOpen} toggle={this.props.toggleExtraValue} >
              <DropdownToggle_s nav caret productCategoryOpen={this.props.extraValueOpen} >
                  <SpanHeader>Extra Value Products</SpanHeader>
              </DropdownToggle_s>
              <DropdownMenu>
                
                <DropdownItem onChange={ this.props.extraSaucesCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_extraSauces} 
                           /> {' '}
                         <p>Sauces</p>
                       </Label>
                  </Container>
                </DropdownItem>
                
                <DropdownItem onChange={ this.props.extraBeveragesCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_extraBeverages} 
                           /> {' '}
                         <p>Beverages</p>
                       </Label>
                  </Container>
                </DropdownItem>

                <DropdownItem onChange={ this.props.extraCandyCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_extraCandy} 
                           /> {' '}
                         <p>Candy</p>
                       </Label>
                  </Container>
                </DropdownItem>

                <DropdownItem onChange={ this.props.extraJellyCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_extraJelly} 
                           /> {' '}
                         <p>Jelly</p>
                       </Label>
                  </Container>
                </DropdownItem>

                <DropdownItem onChange={ this.props.extraGiftSetsCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_extraGiftSets} 
                           /> {' '}
                         <p>Gift Sets</p>
                       </Label>
                  </Container>
                </DropdownItem>

              </DropdownMenu>
            </Dropdown>

            {/* ******************************** NON MAPLE DROPDOWN ******************************** */}
            <Dropdown nav isOpen={this.props.nonMapleOpen} toggle={this.props.toggleNonMaple} >
              <DropdownToggle_s nav caret productCategoryOpen={this.props.nonMapleOpen} >
                  <SpanHeader>Non Maple Products</SpanHeader>
              </DropdownToggle_s>
              <DropdownMenu>

                <DropdownItem onChange={ this.props.nonPancakeMixesCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_nonPancakeMixes} 
                           /> {' '}
                         <p>Pancake Mixes</p>
                       </Label>
                  </Container>
                </DropdownItem>
                
                {/*}
                <DropdownItem onChange={ this.props.nonInformationalCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_nonInformational} 
                           /> {' '}
                         <p>Informational</p>
                       </Label>
                  </Container>
                </DropdownItem>
              */}
                
                <DropdownItem onChange={ this.props.nonClothesCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_nonClothes} 
                           /> {' '}
                         <p>Clothes</p>
                       </Label>
                  </Container>
                </DropdownItem>

                <DropdownItem onChange={ this.props.nonCandlesCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_nonCandles} 
                           /> {' '}
                         <p>Candles</p>
                       </Label>
                  </Container>
                </DropdownItem>
                
                <DropdownItem onChange={ this.props.nonKitchenwareCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_nonKitchenware} 
                           /> {' '}
                         <p>Kitchenware</p>
                       </Label>
                  </Container>
                </DropdownItem>

                <DropdownItem onChange={ this.props.nonBooksCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_nonBooks} 
                           /> {' '}
                         <p>Books</p>
                       </Label>
                  </Container>
                </DropdownItem>

              </DropdownMenu>
            </Dropdown>

          </Nav>

          <DoneBtnContainer>
            <Button onClick={this.props.toggleFilter}>Done</Button>
          </DoneBtnContainer>

        </ShopFilterScreen_Under768_Collapse> 
      </ShopFilterScreen_Under768_CollapseDiv>
    );

    return (
      <FluidContainer className="p-0" fluid>
          {ShopFilterScreen_Under768}
      </FluidContainer>
    );
  }
}

const FluidContainer = styled(Container)`  `;

const Container_Under768 = styled(Container)`  `;


const ShopFilterScreen_Under768_CollapseDiv = styled.div`
  .dropdown-menu {
    position: relative!important;
    transform: none!important;
    padding-top: 0;
    
    button.dropdown-item {
      padding: 0;

      :active, :focus {
        background: #D0C1A0;
        outline: none;
      }
    }

    .container {
      height: 60px;
      line-height: 60px;
      padding-left: 31px;

      label {
        height: 100%;

        input {
          width: 20px;
          height: 20px;
          margin-top: 14px;
        }

        p {
          margin: -6px 0 0 6px;
          font-size: 18px!important;
        }
      }

      :focus {
        outline: none;
      }
    }
  }

  .collapsing {
    height: 0!important;
    width: 0!important;
    transition: height .5s ease, width .5s ease!important;
  }
  .show {
    height: 100%!important;
    width: 100%!important;
    transition: height .5s ease, width .5s ease!important;
  }
`;


const ShopFilterScreen_Under768_Collapse = styled(Collapse)`
  position: fixed!important;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  height: 100%!important;
  width: 100%!important;
  background-color: #D0C1A0;
  color: white;
  z-index: 2;

  .nav-item {
    height: 60px;
    width: 100%;
    line-height: 60px;
    border-bottom: 1px solid #BCA368;
    display: table; 

    div.dropdown-menu {
      background: #D0C1A0;
      margin: 0;
      border: none;
    }

    :hover {
        spanheader {
          border-bottom: none;
        } 
    }

    button {
      :hover {
        background: #D0C1A0;
      }
    }

    a.nav-link {
      margin-left: 16px;
      padding: 0;
      cursor: pointer;

      img {
        display: inline-block;
        float: right;
        width: 20px;
        height: 20px;
        margin: 20px 10px 0 0!important;
        cursor: pointer;
      }

      a {
        color: black;
      }
    }
  }
`;


const SpanInDropdown = styled.span`
  color: black;
`;
const SpanHeader = styled.span`
  color: black;
`;


const DropdownToggle_s = styled(({ productCategoryOpen, ...rest }) => <DropdownToggle {...rest} />)`
    ::after {
      color: black;
        float: right;
        margin: 30px 10px 0 0;
        border-top-width: ${a => a.productCategoryOpen ? "0!important" : "4.3px!important;"};
        border-bottom: ${a => a.productCategoryOpen ? "4.3px solid black!important" : ""};
    }
`;


const DoneBtnContainer = styled(Container)`
    position: absolute!important;
    bottom: 20px!important;
    width: 100%!important;
    height: 60px;
    border-top: 1px solid #8A572A;
    padding: 0!important;

    button {
      width: 90%!important;
      position: absolute;
      bottom: -8px;
      margin: 0 5% 0 5%!important;
      background: #8B572A;
      color: white;
      font-weight: bold;
      cursor: pointer;
      border: none;

      :hover {
        background: #8B572A;
        color: white;
      }
    }
`;


/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/ShopFilterCollapseUnder768.js